import { computed } from 'vue';
import { useRoute } from 'vue-router';

export const useParentId = () => {
  const route = useRoute();

  const pid = computed(() => {
    return route.meta?.pid ? `&pid=${route.meta?.pid}` : '';
  });

  const cid = computed(() => {
    return (route.meta?.pid as string) || '';
  });

  return {
    pid,
    cid,
  };
};
